export const members = [
    {
        name : "Mohit Ranjan",
        image : "Mohit Ranjan.jpg",
        post : "Branch Head",
    
    },
    {
        name : "Arpit Kumar",
        image : "Arpit Kumar.jpg",
        post : "CP Team",
    },
    {
        name : "Ayush Ambasta",
        image : "Ayush Ambasta.jpg",
        post : "Web Team"
    },
    {
        name : "Vikash Kumar",
        image : "Vikash Kumar.jpg",
        post : "Core Team"
    },
    {
        name : " Yogesh Kumar",
        image : "Yogesh Kumar.jpg",
        post : "CP Team"
    },
    {
        name : "Omkar Pandey",
        image : "Omkar Pandey.jpg",
        post : "Creative Team"
    },
    {
        name : "Pratik Sonthaliya",
        image : "Pratik Sonthaliya.jpg",
        post : "Core Team"
    },
    {
        name : "Nilesh Dawn ",
        image : "Nilesh Dawn.jpg",
        post : "EM Team"
    },
    {
        name : "Akanksha Priya",
        image : "Akanksha Priya.jpg",
        post : "Content Team"
    }  
]

export const proff = [ {
    name : "Dr. Amit Prakash",
    image : "Amit Prakash.jpeg",
    post : "Head of Department"
}, 
{
    name : 'Dr. Basudeba',
    lName : 'Behera',
    image : "Basudeba Behera.jpeg",
    post : "Faculty Advisor"
}]

export const secondYear = [
    {
      name : 'Harsh Raj',
      post : 'Corporate Affairs '
    },
    {
      name : 'Indrani Pal',
      post : 'Corporate Affairs '
    },
    {
      name : 'Anshu Kumari',
      post : 'Corporate Affairs '
    },
    {
      name : 'Mayank Raj',
      post : 'Corporate Affairs '
    },
    {
      name : 'Vivek Rawani',
      post : 'Web Developer'
    }, 
    {
        name : 'Aditya Gautam',
        post : 'Android Developer '
    },
    {
        name : 'Anurag Sarkar',
        post : 'Content Team '
    },
    {
        name : 'Manish',
        post : 'Content Team '
    },
    {
        name : 'Diya Singh',
        post : 'Content Team '
    },
    {
        name : 'Gipashu Aryan',
        post : 'Content Team '
    },
    {
        name : 'Pragati Dubey',
        post : 'Content Team '
    },
    {
        name : 'Ankit Raj',
        post : 'Creative Team '
    },
    {
        name : 'Shristy Singh',
        post : 'Creative Team '
    },
    {
        name : 'Nishant Kumar',
        post : 'Creative Team '
    },
    {
        name : 'Priyanshu Sinha',
        post : 'Creative Team '
    },
    {
        name : 'Ashish Satpathy',
        post : 'Creative Team '
    },
    {
        name : 'Abhishek Kumar',
        post : 'Core Team'
    },
    {
        name : 'Rahul Kumar Singh',
        post : 'Core Team'
    },
    {
        name : 'Prajjwal Jain',
        post : 'Event Management'
    },
    {
        name : 'Shruti Dwivedi',
        post : 'Public Realtions'
    },
    {
        name : 'Rishav Kumar',
        post : 'Public Realtions'
    },
    {
        name : 'Ankit Kumar',
        post : 'Event Management'
    },
    {
        name : 'Potta Dhinesh',
        post : 'Event Management'
    },
    {
        name : 'Thondepu Bhogeswar',
        post : 'Event Management'
    },
    
    {
        name : 'Kaif Been Jawed',
        post : 'Event Management'
    },
    {
        name : 'Kushagra Chaudhary',
        post : 'Public Realtions'
    },
    {
        name : 'Mahi Agarwal',
        post : 'Public Realtions'
    },
    {
        name : 'Shaswat',
        post : 'Public Realtions'
    },
    {
        name : 'Nikhil Kumar',
        post : 'Event Management'
    },
   
  ];